export default "__VITE_ASSET__1Sj5cein__"